import type { ReactElement } from 'react';

interface AuthPageHeaderProps {
  activeLeaguesLabel: string;
}

export function AuthPageHeader({ activeLeaguesLabel }: AuthPageHeaderProps): ReactElement {
  return (
    <header className="p-6 relative z-10 py-4 sm:py-8">
      <div className="max-w-5xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-theme-primary-fill flex items-center justify-center shadow-lg shadow-theme-primary/20">
            <span className="text-theme-on-primary-fill font-bold text-lg">PP</span>
          </div>
          <div>
            <h1 className="font-bold text-white text-xl">Parlay Picker</h1>
          </div>
        </div>
        <span className="text-xs text-theme-text-tertiary border border-theme-border/50 px-2 py-1 rounded-full">
          {activeLeaguesLabel}
        </span>
      </div>
    </header>
  );
}
